module.exports = __webpack_public_path__ + "img/187w.4006c7f.jpg";